const instance = (element) => {
  const dom = {
    menu: element.querySelectorAll('.js-menu'),
    toggleBtn: element.querySelector('.js-menu-toggle'),
  };

  const setupListeners = () => {
    dom.toggleBtn?.addEventListener('click', toggle);
  };

  const toggle = () => {
    dom.menu.forEach((menu) => {
      menu.classList.toggle('is-active');
    });

    dom.toggleBtn?.classList.toggle('is-active');
  };

  setupListeners();
};

export default () => {
  const nav = document.querySelectorAll('.js-nav');

  nav.forEach((element) => {
    instance(element);
  });
};
